import {
  useInsert_Block_List_Item_WorkspaceMutation,
  Block_List_FieldsFragmentDoc,
} from '@geerd-nx/shareable-graphql';
export function useCreateBlockWorkspace(blockQuiz: number) {
  const [mutate] = useInsert_Block_List_Item_WorkspaceMutation({
    update: (cache, { data }) => {
      cache.updateFragment(
        {
          fragment: Block_List_FieldsFragmentDoc,
          id: `block_list_item:${blockQuiz}`,
        },
        (existing = {}) => {
          console.log({
            inserted_data: data?.insert_block_list_item_workspace?.returning,
          });
          console.log({
            data: data?.insert_block_list_item_workspace?.returning,
          });
          return {
            ...data,
            block_list_item_workspaces: [
              ...(existing?.block_list_item_workspaces ?? []),
              ...(data?.insert_block_list_item_workspace?.returning ?? []),
            ],
          };
        }
      );
    },
  });

  return mutate;
}
